import { useQuery } from 'react-query';
import { getWeather } from 'api/api';

export const useGetWeather = ({ zipCode, show }) =>
  useQuery({
    queryKey: ['getWeather', show, zipCode],
    queryFn: () => getWeather({ location: zipCode }),
    enabled: !!zipCode && show,
    // Matches useGetCoordinates.js/useStadiumInfo.js's existing retry: 1 -
    // the global default (queryOptions.js) is retry: false, but a single
    // transient WeatherAPI.com failure previously meant a real user had to
    // manually reopen the modal to get a second attempt (react-query treats
    // `show` toggling back to true as a fresh trigger) - one automatic
    // retry gives the same recovery without requiring that.
    retry: 1,
  });
